export default function GET_COPIRIGHT() {
  const $container = $('.p-footer')
  if( $container.length == 0 ) return false
  
  $.get('/hs_data/site_profile.xml').done(data => {
    const $copyright = $('<p>',{class:'p-footer__copyright'}).text(data.querySelector('COPYRIGHT').innerHTML)
    $container.append( $copyright )
  })

}